import athenaClient from "lib/axios/clients";
import { REACT_APP_BASE_URL } from "resources/constants";

const getAttach = async (queryParams, headers) => {
  const config = {
    method: "GET",
    url: `${REACT_APP_BASE_URL}/attach`,
    // eslint-disable-next-line object-shorthand
    headers: headers,
    params: queryParams,
    responseType: "blob",
  };
  return athenaClient(config);
};

export default getAttach;
